'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRenderSuggestionsContainer = exports.renderSectionTitle = exports.renderSuggestion = undefined;

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LocationIcon = require('../../LocationIcon');

var _LocationIcon2 = _interopRequireDefault(_LocationIcon);

var _CamIcon = require('../../CamIcon');

var _CamIcon2 = _interopRequireDefault(_CamIcon);

var _ForecastIcon = require('../../ForecastIcon');

var _ForecastIcon2 = _interopRequireDefault(_ForecastIcon);

var _TravelIcon = require('../../TravelIcon');

var _TravelIcon2 = _interopRequireDefault(_TravelIcon);

var _analytics = require('../../NewSpotSearch/analytics');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uuid = function uuid() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (a) {
    return (a ^ Math.random() * 16 >> a / 4).toString(16);
  });
};

var renderSuggestion = exports.renderSuggestion = function renderSuggestion(searchTerm) {
  return function (suggestion) {
    var _suggestion$_source = suggestion._source,
        cams = _suggestion$_source.cams,
        breadCrumbs = _suggestion$_source.breadCrumbs,
        name = _suggestion$_source.name,
        _type = suggestion._type;

    var indexOfSearchTerm = name.toLowerCase().indexOf(searchTerm.toLowerCase());
    var nameContent = void 0;
    if (indexOfSearchTerm > -1) {
      var searchTermLength = searchTerm.length;
      var resultTermLength = name.length;
      var endOfHighlight = indexOfSearchTerm + searchTermLength;
      nameContent = _react2.default.createElement(
        'a',
        null,
        name.substring(0, indexOfSearchTerm),
        _react2.default.createElement(
          'highlight',
          null,
          name.substring(indexOfSearchTerm, endOfHighlight)
        ),
        name.substring(endOfHighlight, resultTermLength)
      );
    } else {
      nameContent = _react2.default.createElement(
        'a',
        null,
        name.toLowerCase().split('').map(function (char, index) {
          return searchTerm.toLowerCase().indexOf(char) > -1 && index <= name.toLowerCase().indexOf(char) ? _react2.default.createElement(
            'highlight',
            {
              key: uuid()
            },
            name[index]
          ) : name[index];
        })
      );
    }

    var camClassName = '';
    var iconContent = '';
    var breadCrumbClassName = 'quiver-spot-search__container__subtitle';
    var types = ['geoname', 'subregion', 'spot', 'travel'];
    if (types.indexOf(_type) > -1) {
      if (cams && cams.length && cams[0] !== null) {
        camClassName = 'quiver-spot-search__container__icon__hd-cam';
        iconContent = _react2.default.createElement(_CamIcon2.default, null);
      } else {
        camClassName = 'quiver-spot-search__container__icon__location';
        iconContent = _react2.default.createElement(_LocationIcon2.default, null);
      }
    }

    var breadcrumb = breadCrumbs ? breadCrumbs.join(' / ') : '';
    breadcrumb = breadCrumbs && breadCrumbs.length > 1 ? breadCrumbs[0] + ' / ' + breadCrumbs[breadCrumbs.length - 1] : null;
    breadCrumbClassName = 'quiver-search__container__subtitle';
    if (types.indexOf(_type) > -1) {
      camClassName = 'quiver-search__suggestion__result';
      if (cams && cams.length && cams[0] !== null) {
        iconContent = _react2.default.createElement(_CamIcon2.default, null);
      } else if (_type.indexOf('spot') !== -1) {
        camClassName = 'quiver-search__suggestion__result__blank';
        iconContent = null;
      } else if (_type.indexOf('subregion') !== -1) {
        iconContent = _react2.default.createElement(_ForecastIcon2.default, null);
      } else if (_type.indexOf('travel') !== -1) {
        iconContent = _react2.default.createElement(_TravelIcon2.default, null);
      } else {
        iconContent = _react2.default.createElement(_LocationIcon2.default, null);
      }
    }

    return _react2.default.createElement(
      'div',
      { className: camClassName },
      iconContent,
      nameContent,
      _react2.default.createElement(
        'div',
        { className: breadCrumbClassName },
        breadcrumb
      )
    );
  };
};

var renderSectionTitle = exports.renderSectionTitle = function renderSectionTitle(section) {
  var hits = section.hits.hits,
      suggest = section.suggest;


  var suggestTypes = new _map2.default();
  suggestTypes.set('spot-suggest', 'Surf Spots');
  suggestTypes.set('subregion-suggest', 'Regional Forecast');
  suggestTypes.set('geoname-suggest', 'Map Area');
  suggestTypes.set('travel-suggest', 'Travel Guide');

  if (suggest) {
    var ret = (0, _from2.default)(suggestTypes.entries()).find(function (entry) {
      return suggest[entry[0]] && (suggest[entry[0]][0].options.length > 0 || hits.length > 0);
    });
    if (ret) return ret[1];
  }

  return null;
};

var renderSuggestionsContainer = function renderSuggestionsContainer(window, _ref) {
  var containerProps = _ref.containerProps,
      children = _ref.children,
      query = _ref.query;
  return _react2.default.createElement(
    'div',
    containerProps,
    children,
    _react2.default.createElement(
      'div',
      { className: 'footer' },
      _react2.default.createElement(
        'a',
        {
          href: '/search/' + query,
          onClick: function onClick() {
            return (0, _analytics.clickedSearchResults)(window, null, {
              searchId: null,
              searchResultRank: null,
              destinationPage: '/search/' + query,
              queryTerm: query,
              resultName: null,
              searchLatency: null,
              resultType: 'see all results'
            }, function () {});
          }
        },
        'See all results'
      )
    )
  );
};

renderSuggestionsContainer.propTypes = {
  children: _propTypes2.default.node,
  query: _propTypes2.default.string,
  containerProps: _propTypes2.default.shape
};

var getRenderSuggestionsContainer = exports.getRenderSuggestionsContainer = function getRenderSuggestionsContainer(window) {
  return function (props) {
    return renderSuggestionsContainer(window, props);
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/NewSpotSearch/NewSpotSuggestion/NewSpotSuggestionRender.js
// module id = 614
// module chunks = 11